import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

import { dayHeader } from './styles'

class Header extends PureComponent {
  static propTypes = {
    label: PropTypes.string
  }

  render() {
    const { label } = this.props
    const [day, month] = label.split(' ')
    return (
      <div className="header">
        <div className="day">{day}</div>
        <div className="month">{month}</div>
        <style jsx>{dayHeader}</style>
      </div>
    )
  }
}

export default Header
